<template>
  <div class="template-wrap">
    <template v-for="(item, index) in formData">
      <div :key="item.id" class="template-content">
        <FormItem :ref="`formItem_${index}`" v-model="formData[index]" />
        <div class="btn-wrap">
          <i class="iconfont el-icon-plus" @click="addCustomerForm(index)" />
          <i v-if="formData.length !== 1" class="iconfont el-icon-minus" @click="removeCustomerForm(index)" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import FormItem from './formItem.vue';
export default {
  components: {
    FormItem
  },

  model: {
    prop: 'data',
    event: 'change'
  },

  props: {
    data: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      formData: [{ id: +new Date() }]
    };
  },

  watch: {
    formData (newVal) {
      this.$emit('change', newVal);
    }
  },

  methods: {
    addCustomerForm (index) {
      this.formData.splice(index + 1, 0, { id: +new Date() });
    },

    removeCustomerForm (index) {
      this.formData.splice(index, 1);
    },

    validateForm () {
      let arr = [];
      for (let i = 0; i < this.formData.length; i++) {
        this.$refs[`formItem_${i}`][0].validateForm((val) => arr.push(val));
      }
      return !arr.some(val => val === false);
    }
  }
};
</script>

<style lang="scss" scoped>
.template-wrap {
  margin-bottom: 8px;
  padding: 14px 10px;
  background: #fff;
  border-radius: 4px;
  .template-content{
    display: flex;
    .btn-wrap{
      margin-top: 4px;
      .iconfont{
        margin-left: 8px;
      }
    }
  }
}
</style>
